import { Progress } from 'antd';
import { ReactNode } from 'react';
import { colors } from 'theme/colors';

import type { FooterButton } from 'components/feedback/drawer/Drawer';
import { Button } from 'components/general/Button';

interface RenderFooterProps {
  footerActions?: FooterButton[];
  footerExtra?: ReactNode;
  stepProps?: StepProps;
}

interface StepProps {
  currentStep: number;
  totalSteps: number;
  strokeColor?: string;
  railColor?: string;
}

export const RenderFooter = ({
  footerActions,
  footerExtra,
  stepProps,
}: RenderFooterProps) => {
  if (!footerActions?.length && !footerExtra) return null;

  return (
    <div className="flex items-center justify-between">
      {stepProps ? (
        <Progress
          format={(percent: number | undefined) => {
            const currentStep =
              percent !== undefined ? percent * 0.01 * stepProps.totalSteps : 0;
            return `${currentStep} / ${stepProps.totalSteps}`;
          }}
          size={{ height: 8, width: 64 }}
          percent={(stepProps.currentStep / stepProps.totalSteps) * 100}
          steps={stepProps.totalSteps}
          strokeColor={stepProps.strokeColor ?? colors.primaryGreen5}
          railColor={stepProps.railColor}
          status="normal"
        />
      ) : null}
      <div className="flex-1">{footerExtra}</div>
      <div className="flex items-center space-x-2">
        {footerActions?.map((action, index) => (
          <Button key={index} {...action}>
            {action.text}
          </Button>
        ))}
      </div>
    </div>
  );
};
